import { useStopTransactionalCommunication } from '@axo/shared/data-access/hooks/mutations/useStopTransactionalCommunication';
import { AppToaster } from '../../AppToaster';

export const MUTED_MESSAGE =
  'Transactional communication has been muted for the current session.';

/**
 * Mutes a customer's transactional communication and tells the agent how it
 * went. The shared command refetches the customer's records on success, which
 * turns the button into its muted state.
 */
export function useMuteTransactionalCommunication() {
  const stop = useStopTransactionalCommunication();

  const execute = async (params: { customerID: string; country: string }) => {
    try {
      await stop.mutateAsync(params);
      (await AppToaster).show({ intent: 'success', message: MUTED_MESSAGE });
    } catch (error) {
      const reason = error instanceof Error ? error.message : 'Unknown error';
      (await AppToaster).show({
        intent: 'danger',
        message: `Failed to mute transactional communication: ${reason}`,
      });
    }
  };

  return { execute, isLoading: stop.isLoading };
}
